import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { IResponseApi, IResponsePost } from "../../../../Interfaces/base/IResponse";
import { IRequestCargaMasivaEquipoTrabajo } from "../../../../Interfaces/IPersona";
import { IExcelFile, ILog } from "../../../../Interfaces/IFile";
import { ILoggerCallback } from "@azure/msal-browser";
import personaServicio from "../../../../services/persona/personaServicio";
import { AxiosError } from "axios";
import { BlobService } from "../../../../services/Blob/BlobService";

export const usePanelCargaMasivaSupervisores = (props: IOpenPanel) => {

    const [isSubmit, setIsSubmit] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [excelFile, setExcelFile] = useState<IExcelFile>();
    const [response, setResponse] = useState<IResponsePost>();
    const [request, setRequest] = useState<IRequestCargaMasivaEquipoTrabajo>({
        archivo: excelFile?.file || "",
    });

    const [log, setLog] = useState<ILog[]>([]);

    useEffect(() => {
        if (!props.isOpen) {
        setExcelFile(null!);
        setLog([]);
        }
    }, [props.isOpen]);

    const subirDocumento = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLog([]);
        const files = event.target.files;

        if (files && files.length > 0) {
        const file: File = files[0];

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64WithPrefix = reader.result as string;
            const base64 = base64WithPrefix.split(",")[1];

            setExcelFile({
            file: base64,
            nombreArchivo: file.name.substring(0, file.name.indexOf(".xls")),
            tamanio: file.size,
            tipo: file.type,
            });
        };
        reader.readAsDataURL(file);
        }
    };

    const subir = (file: IExcelFile) => {
        setLoading(true);
        setIsSubmit(true);
        personaServicio.CrearEquipoTrabajoMasivo(
        {
            archivo: file.file,
        }
        )
        .then((res) => {
            setLoading(false);
            if (res.status == 200 && res.data.confirmacion == true) {
                setResponse({
                mensaje: res.data.mensaje,
                codigoMensaje: 1,
                });
                setLog(res.data.logs || []);
                setTimeout(() => {
                limpiarResponse();
                }, 3000);
            }else {
                setResponse({
                mensaje: res.data.mensaje,
                codigoMensaje: 2,
                });
                setLog(res.data.logs || []);
                setTimeout(() => {
                limpiarResponse();
                }, 5000);
            }
        })
        .catch((e: AxiosError) => {
            console.log(e);
            setLoading(false);
            const errorData = e.response?.data as { title: string };
            setResponse({
            mensaje: errorData.title,
            codigoMensaje: 2,
            });
            setTimeout(() => {
            limpiarResponse();
            }, 5000);
        });
    };

    const limpiarResponse = () => {
        setResponse({
            mensaje: "",
            codigoMensaje: 0,
        });
    };

     const descargarPlantilla = () => {
        setLoader(true);
        BlobService.getFileByBlob({
            listUrlBase: ["PlantillaEquipoTrabajo.xlsx"],
            codContenedor: "36"
        }).then(
        (res) => {
            if (res.status === 200) {
            setLoader(false);
            if (res.data) {
                const link = document.createElement("a");
                link.href = `${res.data}`;
                link.download = `PlantillaEquipoTrabajo.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                setResponse({
                mensaje: "No hay datos disponibles para descargar",
                codigoMensaje: 2,
                });
                setTimeout(() => {
                limpiarResponse();
                }, 2000);
            } 
            }
        }
        );
    };

    const eliminarDocumento = () => {
        setExcelFile(undefined);
        setRequest({
        ...request,
        archivo: "",
        });
        setIsSubmit(false);
        setLog([]);
    };


    return {
        isSubmit,
        loader,
        loading,
        excelFile,
        response,
        request,
        log,
        subirDocumento,
        subir,
        limpiarResponse,
        descargarPlantilla,
        eliminarDocumento,
    };
}
